<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :compare="true"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-absatz"
                                           v-model="config.einkaufAbsatz">
                                    <label class="form-check-label" for="einkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-umsatz"
                                           v-model="config.einkaufUmsatz">
                                    <label class="form-check-label" for="einkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-absatz"
                                           v-model="config.verkaufAbsatz">
                                    <label class="form-check-label" for="verkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-umsatz"
                                           v-model="config.verkaufUmsatz">
                                    <label class="form-check-label" for="verkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-In</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellIn.mode']"></i>
                            <b>Modus</b>
                        </label>
                        <select class="form-control" v-model="config.sellInMode">
                            <option value="all-split">Anbieter und Großhandel - Getrennt</option>
                            <option value="all-sum">Anbieter und Großhandel - Summe</option>
                            <option value="anbieter">Anbieter</option>
                            <option value="grosshandel">Großhandel</option>
                        </select>
                        <div class="form-check mt-2" v-if="config.sellInMode !== 'all-sum'">
                            <input class="form-check-input" type="checkbox" value="" id="sell-in-mode-switch"
                                   v-model="config.sellInModeSwitch">
                            <label class="form-check-label" for="sell-in-mode-switch">
                                <i class="fas fa-info-circle text-muted"
                                   style=""
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   :title="$info['sellIn.modeSwitch']"></i>
                                Überweiser in Direktgeschäft
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <fieldset class="border px-3 mb-3">
                                <legend class="w-auto">{{ sellInHeaders[0] }}</legend>

                                <div class="form-group">
                                    <label><b>Umsatz Basis</b></label>
                                    <select class="form-control" v-model="config.sellIn1Base">
                                        <option value="listenek">Listen EK</option>
                                        <option value="nettoek">Netto EK</option>
                                        <option value="listenvk">Listen VK</option>
                                        <option value="kalkuliertervk">Kalkulierter VK</option>
                                    </select>
                                </div>

                                <div class="form-check my-2"
                                     v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn1Base)">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-1-tax"
                                           v-model="config.sellIn1RemoveTax">
                                    <label class="form-check-label" for="sell-in-1-tax">
                                        <i class="fas fa-info-circle text-muted"
                                           style=""
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           :title="$info['sellOut.removeTax']"></i>
                                        Mwst. herausrechnen
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                        <div class="col" v-if="sellInHeaders.length > 1">
                            <fieldset class="border px-3 mb-3">
                                <legend class="w-auto">{{ sellInHeaders[1] }}</legend>

                                <div class="form-group">
                                    <label><b>Umsatz Basis</b></label>
                                    <select class="form-control" v-model="config.sellIn2Base">
                                        <option value="listenek">Listen EK</option>
                                        <option value="nettoek">Netto EK</option>
                                        <option value="listenvk">Listen VK</option>
                                        <option value="kalkuliertervk">Kalkulierter VK</option>
                                    </select>
                                </div>

                                <div class="form-check my-2"
                                     v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn2Base)">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-2-tax"
                                           v-model="config.sellIn2RemoveTax">
                                    <label class="form-check-label" for="sell-in-2-tax">
                                        <i class="fas fa-info-circle text-muted"
                                           style=""
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           :title="$info['sellOut.removeTax']"></i>
                                        Mwst. herausrechnen
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-Out</legend>

                    <div class="form-group">
                        <label><b>Umsatz Basis</b></label>
                        <select class="form-control" v-model="config.sellOutBase">
                            <option value="listenek">Listen EK</option>
                            <option value="nettoek">Netto EK</option>
                            <option value="listenvk">Listen VK</option>
                            <option value="listenvkfallback">Listen VK (Fallback)</option>
                            <option value="tatsaechlichervk">Netto VK</option>
                        </select>
                    </div>

                    <div class="form-check my-2"
                         v-if="['listenvk', 'listenvkfallback', 'tatsaechlichervk'].includes(config.sellOutBase)">
                        <input class="form-check-input" type="checkbox" value="" id="sell-out-tax"
                               v-model="config.sellOutRemoveTax">
                        <label class="form-check-label" for="sell-out-tax">
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellOut.removeTax']"></i>
                            Mwst. herausrechnen
                        </label>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Weitere Seiten</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['pages.anbieter']"></i>
                            <b>Anbieter</b>
                        </label>
                        <select class="form-control" v-model="config.pageAnbieter">
                            <option value="disabled">Deaktiviert</option>
                            <option value="simple">Anbieter über alle PZN Gruppen</option>
                            <option value="advanced">Anbieter innerhalb jeder PZN Gruppe</option>
                        </select>
                    </div>
                </fieldset>

                <fieldset class="border px-3" v-if="!(options.disabledFeatures || []).includes('panel_settings')">
                    <legend class="w-auto">Prozentregelung</legend>

                    <div class="form-group" v-if="config.timing.comparePeriods">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPercent']"></i>
                            <b>Panelgröße</b>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelBase']"></i>
                            <b>Berechnungsgrundlage</b>
                        </label>
                        <select class="form-control" v-model="config.panelBase">
                            <option value="sell-out">Sell Out</option>
                            <option value="sell-in">Sell In</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPeriod']"></i>
                            <b>Startdatum Modus</b>
                        </label>
                        <select class="form-control" v-model="config.panelPeriod">
                            <option value="full">Gesamtzeitraum</option>
                            <option value="quarterly-start">Quartalsweise - Anfang</option>
                            <option value="quarterly-middle">Quartalsweise - Mitte</option>
                            <option value="quarterly-end">Quartalsweise - Ende</option>
                            <option value="monthly">Monatlich</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="!(options.disabledFeatures || []).includes('panel_filter_pzn')">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['markt.panelFilter']"></i>
                            Filter PZN
                        </label>
                        <custom-select v-model="config.panelPzn"
                                       ref="panelPzn"
                                       :settings="pznSettings"/>
                        <div class="mt-1">
                            <button type="button" class="btn btn-sm btn-outline-primary mr-1"
                                    v-for="group in panelPznSuggestions"
                                    @click="addPanelPznGroup(group)">
                                Hinzufügen: {{ group }}
                            </button>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['markt.panelFilter']"></i>
                            Filter Anbieter
                        </label>
                        <custom-select v-model="config.panelAnbieter"
                                       :settings="anbieterSettings"/>
                    </div>
                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :pzn="false"
                          :pzn-groups="true"
                          :warengruppen="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :reimport="true"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
            pznSettings: {
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            anbieterSettings: {
                ajax: {
                    url: '/select/anbieter',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
        };
    },
    methods: {
        addPanelPznGroup(group) {
            const entry = 'group:' + group;
            this.$refs.panelPzn.addOption(entry, 'Gruppe: ' + group);
            this.config.panelPzn.push(entry);
        }
    },
    computed: {
        sellInHeaders() {
            const headers = [];
            if (this.config.sellInMode === 'all-sum') {
                headers.push('Summe');
            }
            if (this.config.sellInMode === 'all-split') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Direkt & Überweiser');
                    headers.push('Großhandel');
                } else {
                    headers.push('Direkt');
                    headers.push('Großhandel');
                }
            }
            if (this.config.sellInMode === 'anbieter') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Direkt & Überweiser');
                } else {
                    headers.push('Direkt');
                }
            }
            if (this.config.sellInMode === 'grosshandel') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Großhandel ohne Überweiser');
                } else {
                    headers.push('Großhandel');
                }
            }

            return headers;
        },
        panelPznSuggestions() {
            if (Array.isArray(this.config.filtering.pznGroups)) {
                return [];
            }

            return Object.keys(this.config.filtering.pznGroups).filter((group) => {
                return !this.config.panelPzn.includes('group:' + group);
            });
        }
    }
}
</script>
